(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bevgru-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * One add-to-cart for every Bevgru section. Speaks Horizon's own protocol -
   * names the cart sections so the response carries fresh drawer HTML, and
   * dispatches CartLinesUpdateEvent with a promise the drawer resolves against -
   * so the drawer refreshes and opens exactly as it would for a native add.
   * Any other theme gets the generic events and, if it has a drawer, a nudge.
   */
  if (!window.bevgruCartAdd) {
    window.bevgruCartAdd = async function (id, quantity) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((el) => el.dataset.sectionId);

      let events = null;
      try { events = await import('@shopify/events'); } catch (error) { events = null; }
      const Native = events && events.CartLinesUpdateEvent;
      const deferred = Native ? Native.createPromise() : null;
      if (Native) {
        document.dispatchEvent(new Native({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity }],
          promise: deferred.promise,
        }));
      }

      try {
        const body = { items: [{ id: Number(id), quantity }] };
        if (sectionIds.length) body.sections = sectionIds.join(',');
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message);

        const cart = await (await fetch(root + 'cart.js')).json();
        if (Native) {
          deferred.resolve({
            cart: Native.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items, source: 'bevgru', sourceId: 'bevgru',
              itemCount: quantity, sections: data.sections, didError: false,
            },
          });
        }
        ['cart:update', 'cart:refresh', 'cart-update'].forEach((name) => {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'bevgru', cart } }));
        });

        // Open the drawer if the theme has one and it has not opened itself.
        const drawer = document.querySelector('#cart-drawer, cart-drawer, cart-drawer-component');
        const open = drawer && (drawer.open || drawer.showDialog);
        if (drawer && !drawer.hasAttribute('open') && typeof open === 'function') open.call(drawer);
        return cart;
      } catch (error) {
        if (deferred) deferred.reject(error);
        throw error;
      }
    };
  }

  if (!customElements.get('bevgru-add')) {
    customElements.define(
      'bevgru-add',
      class BevgruAdd extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('[data-add]');
          this.status = this.querySelector('[data-status]');
          if (!this.form || this.dataset.ajax !== 'true') return;
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.add();
          });
        }

        async add() {
          const label = this.button.textContent;
          this.button.disabled = true;
          this.button.textContent = 'Adding…';
          try {
            const id = this.form.querySelector('[name="id"]').value;
            const qty = Number((this.form.querySelector('[name="quantity"]') || {}).value || 1);
            await window.bevgruCartAdd(id, qty);
            this.button.textContent = 'Added ✓';
            if (this.status) this.status.hidden = false;
          } catch (error) {
            this.button.textContent = 'Could not add';
            console.error('[bevgru] add to cart failed', error);
          } finally {
            setTimeout(() => {
              this.button.disabled = false;
              this.button.textContent = label;
            }, 2200);
          }
        }
      }
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bevgru-featured-product"] && !Shopify.designMode) return;
  try {
    
  /**
   * One add-to-cart for every Bevgru section. Speaks Horizon's own protocol -
   * names the cart sections so the response carries fresh drawer HTML, and
   * dispatches CartLinesUpdateEvent with a promise the drawer resolves against -
   * so the drawer refreshes and opens exactly as it would for a native add.
   * Any other theme gets the generic events and, if it has a drawer, a nudge.
   */
  if (!window.bevgruCartAdd) {
    window.bevgruCartAdd = async function (id, quantity) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((el) => el.dataset.sectionId);

      let events = null;
      try { events = await import('@shopify/events'); } catch (error) { events = null; }
      const Native = events && events.CartLinesUpdateEvent;
      const deferred = Native ? Native.createPromise() : null;
      if (Native) {
        document.dispatchEvent(new Native({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity }],
          promise: deferred.promise,
        }));
      }

      try {
        const body = { items: [{ id: Number(id), quantity }] };
        if (sectionIds.length) body.sections = sectionIds.join(',');
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message);

        const cart = await (await fetch(root + 'cart.js')).json();
        if (Native) {
          deferred.resolve({
            cart: Native.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items, source: 'bevgru', sourceId: 'bevgru',
              itemCount: quantity, sections: data.sections, didError: false,
            },
          });
        }
        ['cart:update', 'cart:refresh', 'cart-update'].forEach((name) => {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'bevgru', cart } }));
        });

        // Open the drawer if the theme has one and it has not opened itself.
        const drawer = document.querySelector('#cart-drawer, cart-drawer, cart-drawer-component');
        const open = drawer && (drawer.open || drawer.showDialog);
        if (drawer && !drawer.hasAttribute('open') && typeof open === 'function') open.call(drawer);
        return cart;
      } catch (error) {
        if (deferred) deferred.reject(error);
        throw error;
      }
    };
  }

  if (!customElements.get('bevgru-add')) {
    customElements.define(
      'bevgru-add',
      class BevgruAdd extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('[data-add]');
          this.status = this.querySelector('[data-status]');
          if (!this.form || this.dataset.ajax !== 'true') return;

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.add();
          });
        }

        async add() {
          const label = this.button.textContent;
          this.button.disabled = true;
          this.button.textContent = 'Adding…';
          try {
            const id = this.form.querySelector('[name="id"]').value;
            const qty = Number((this.form.querySelector('[name="quantity"]') || {}).value || 1);
            await window.bevgruCartAdd(id, qty);
            this.button.textContent = 'Added ✓';
            if (this.status) this.status.hidden = false;
          } catch (error) {
            this.button.textContent = 'Could not add';
            console.error('[bevgru] add to cart failed', error);
          } finally {
            setTimeout(() => {
              this.button.disabled = false;
              this.button.textContent = label;
            }, 2200);
          }
        }
      }
    );
  }

  if (!customElements.get('bevgru-gallery')) {
    customElements.define(
      'bevgru-gallery',
      class BevgruGallery extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('.bev-feature__frame');
          this.shots = Array.from(this.querySelectorAll('.bev-feature__shot'));
          this.thumbs = Array.from(this.closest('.bev-feature__gallery').querySelectorAll('[data-goto]'));
          if (this.shots.length < 2) return;
          this.frame.classList.add('is-ready');
          this.show(0);
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.show(Number(thumb.dataset.goto)))
          );
        }

        show(index) {
          this.shots.forEach((shot, i) => shot.classList.toggle('is-active', i === index));
          this.thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === index);
            thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
      }
    );
  }

  if (!customElements.get('bevgru-variants')) {
    // Keeps the headline price honest when the pack changes.
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-variants]');
      if (!select) return;
      const root = select.closest('.bev-feature__details');
      const option = select.selectedOptions[0];
      const price = root.querySelector('[data-price]');
      const compare = root.querySelector('[data-compare]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare && option.dataset.compare) compare.textContent = option.dataset.compare;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bevgru-flavour-rail"] && !Shopify.designMode) return;
  try {
    
  /**
   * One add-to-cart for every Bevgru section. Speaks Horizon's own protocol -
   * names the cart sections so the response carries fresh drawer HTML, and
   * dispatches CartLinesUpdateEvent with a promise the drawer resolves against -
   * so the drawer refreshes and opens exactly as it would for a native add.
   * Any other theme gets the generic events and, if it has a drawer, a nudge.
   */
  if (!window.bevgruCartAdd) {
    window.bevgruCartAdd = async function (id, quantity) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((el) => el.dataset.sectionId);

      let events = null;
      try { events = await import('@shopify/events'); } catch (error) { events = null; }
      const Native = events && events.CartLinesUpdateEvent;
      const deferred = Native ? Native.createPromise() : null;
      if (Native) {
        document.dispatchEvent(new Native({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity }],
          promise: deferred.promise,
        }));
      }

      try {
        const body = { items: [{ id: Number(id), quantity }] };
        if (sectionIds.length) body.sections = sectionIds.join(',');
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message);

        const cart = await (await fetch(root + 'cart.js')).json();
        if (Native) {
          deferred.resolve({
            cart: Native.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items, source: 'bevgru', sourceId: 'bevgru',
              itemCount: quantity, sections: data.sections, didError: false,
            },
          });
        }
        ['cart:update', 'cart:refresh', 'cart-update'].forEach((name) => {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'bevgru', cart } }));
        });

        // Open the drawer if the theme has one and it has not opened itself.
        const drawer = document.querySelector('#cart-drawer, cart-drawer, cart-drawer-component');
        const open = drawer && (drawer.open || drawer.showDialog);
        if (drawer && !drawer.hasAttribute('open') && typeof open === 'function') open.call(drawer);
        return cart;
      } catch (error) {
        if (deferred) deferred.reject(error);
        throw error;
      }
    };
  }

  if (!customElements.get('bevgru-add')) {
    customElements.define(
      'bevgru-add',
      class BevgruAdd extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('[data-add]');
          this.status = this.querySelector('[data-status]');
          if (!this.form || this.dataset.ajax !== 'true') return;

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.add();
          });
        }

        async add() {
          const label = this.button.textContent;
          this.button.disabled = true;
          this.button.textContent = 'Adding…';
          try {
            const id = this.form.querySelector('[name="id"]').value;
            const qty = Number((this.form.querySelector('[name="quantity"]') || {}).value || 1);
            await window.bevgruCartAdd(id, qty);
            this.button.textContent = 'Added ✓';
            if (this.status) this.status.hidden = false;
          } catch (error) {
            this.button.textContent = 'Could not add';
            console.error('[bevgru] add to cart failed', error);
          } finally {
            setTimeout(() => {
              this.button.disabled = false;
              this.button.textContent = label;
            }, 2200);
          }
        }
      }
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bevgru-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bevgru-header')) {
    customElements.define(
      'bevgru-header',
      class BevgruHeader extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('[data-drawer]');
          this.toggle = this.querySelector('[data-menu-toggle]');
          this.count = this.querySelector('[data-cart-count]');

          this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 8);
          this.onScroll();
          window.addEventListener('scroll', this.onScroll, { passive: true });

          if (this.toggle) this.toggle.addEventListener('click', () => this.toggleMenu());

          this.addEventListener('click', (event) => {
            const cart = event.target.closest('[data-cart-toggle]');
            if (cart) this.openCart(event);
          });

          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.classList.contains('is-open')) this.toggleMenu(false);
          });

          // Any cart change on the page refreshes the bubble: our own events, and
          // Horizon's, which fire before the mutation lands and carry a promise
          // for it, so wait on that before reading the cart back.
          ['cart:update', 'cart:refresh', 'cart-update'].forEach((name) => {
            document.addEventListener(name, () => this.refresh());
          });
          import('@shopify/events')
            .then(({ StandardEvents }) => {
              Object.values(StandardEvents)
                .filter((name) => typeof name === 'string' && name.includes(':cart:'))
                .forEach((name) => {
                  document.addEventListener(name, async (event) => {
                    const settled = event.promise || (event.detail && event.detail.promise);
                    if (settled && typeof settled.then === 'function') await settled.catch(() => {});
                    this.refresh();
                  });
                });
            })
            .catch(() => {});
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
        }

        toggleMenu(force) {
          const open = force === undefined ? !this.classList.contains('is-open') : force;
          this.classList.toggle('is-open', open);
          if (this.drawer) this.drawer.hidden = !open;
          if (this.toggle) {
            this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            this.toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
            // `.hidden` is an HTMLElement property; on an inline <svg> it is a no-op.
            this.toggle.querySelector('[data-burger-open]').toggleAttribute('hidden', open);
            this.toggle.querySelector('[data-burger-close]').toggleAttribute('hidden', !open);
          }
          document.body.style.overflow = open ? 'hidden' : '';
        }

        /* Upgrade the cart link to the theme's drawer when one is on the page.
           No drawer, no JavaScript, or an unknown theme: the link navigates. */
        openCart(event) {
          const drawer = document.querySelector(
            '#cart-drawer, cart-drawer, cart-drawer-component, cart-notification, #CartDrawer'
          );
          if (!drawer) return;
          const open = drawer.open || drawer.toggle || drawer.show || drawer.showDialog;
          if (typeof open !== 'function') return;
          event.preventDefault();
          open.call(drawer);
        }

        async refresh() {
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await response.json();
            if (!this.count) return;
            this.count.textContent = cart.item_count;
            this.count.hidden = cart.item_count === 0;
          } catch (error) {
            console.error('[bevgru] cart count refresh failed', error);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bevgru-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bevgru-carousel')) {
    customElements.define(
      'bevgru-carousel',
      class BevgruCarousel extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.bev-hero__slide'));
          this.dots = Array.from(this.querySelectorAll('.bev-hero__dot'));
          this.index = 0;
          if (this.slides.length < 2) return;

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.interval = parseInt(this.dataset.interval, 10) || 5500;

          this.addEventListener('click', (event) => {
            const dot = event.target.closest('[data-goto]');
            if (dot) return this.show(parseInt(dot.dataset.goto, 10));
            const arrow = event.target.closest('[data-step]');
            if (arrow) return this.show(this.index + parseInt(arrow.dataset.step, 10));
          });

          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.play());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.play());
          document.addEventListener('visibilitychange', () =>
            document.hidden ? this.stop() : this.play()
          );

          // The theme editor re-renders blocks; follow the merchant's selection.
          document.addEventListener('shopify:block:select', (event) => {
            const slide = event.target.closest('.bev-hero__slide');
            if (slide && this.contains(slide)) {
              this.stop();
              this.show(parseInt(slide.dataset.index, 10));
            }
          });

          this.play();
        }

        disconnectedCallback() {
          this.stop();
        }

        show(next) {
          const total = this.slides.length;
          this.index = ((next % total) + total) % total;
          this.slides.forEach((slide, i) => {
            const active = i === this.index;
            slide.classList.toggle('is-active', active);
            slide.toggleAttribute('aria-hidden', !active);
            slide.querySelectorAll('a').forEach((link) => {
              link.tabIndex = active ? 0 : -1;
            });
          });
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === this.index);
            dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
          });
        }

        play() {
          if (this.reduced || this.dataset.autoplay !== 'true' || this.timer) return;
          this.timer = setInterval(() => this.show(this.index + 1), this.interval);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bevgru-main-product"] && !Shopify.designMode) return;
  try {
    
  /**
   * One add-to-cart for every Bevgru section. Speaks Horizon's own protocol -
   * names the cart sections so the response carries fresh drawer HTML, and
   * dispatches CartLinesUpdateEvent with a promise the drawer resolves against -
   * so the drawer refreshes and opens exactly as it would for a native add.
   * Any other theme gets the generic events and, if it has a drawer, a nudge.
   */
  if (!window.bevgruCartAdd) {
    window.bevgruCartAdd = async function (id, quantity) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((el) => el.dataset.sectionId);

      let events = null;
      try { events = await import('@shopify/events'); } catch (error) { events = null; }
      const Native = events && events.CartLinesUpdateEvent;
      const deferred = Native ? Native.createPromise() : null;
      if (Native) {
        document.dispatchEvent(new Native({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity }],
          promise: deferred.promise,
        }));
      }

      try {
        const body = { items: [{ id: Number(id), quantity }] };
        if (sectionIds.length) body.sections = sectionIds.join(',');
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message);

        const cart = await (await fetch(root + 'cart.js')).json();
        if (Native) {
          deferred.resolve({
            cart: Native.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items, source: 'bevgru', sourceId: 'bevgru',
              itemCount: quantity, sections: data.sections, didError: false,
            },
          });
        }
        ['cart:update', 'cart:refresh', 'cart-update'].forEach((name) => {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'bevgru', cart } }));
        });

        // Open the drawer if the theme has one and it has not opened itself.
        const drawer = document.querySelector('#cart-drawer, cart-drawer, cart-drawer-component');
        const open = drawer && (drawer.open || drawer.showDialog);
        if (drawer && !drawer.hasAttribute('open') && typeof open === 'function') open.call(drawer);
        return cart;
      } catch (error) {
        if (deferred) deferred.reject(error);
        throw error;
      }
    };
  }

  if (!customElements.get('bevgru-pdp-gallery')) {
    customElements.define(
      'bevgru-pdp-gallery',
      class BevgruPdpGallery extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('.bev-pdp__frame');
          this.shots = Array.from(this.querySelectorAll('.bev-pdp__shot'));
          this.thumbs = Array.from(this.querySelectorAll('[data-goto]'));
          this.counter = this.querySelector('[data-counter]');
          this.live = this.querySelector('[data-live]');
          if (this.shots.length < 2) return;

          this.index = 0;
          this.frame.classList.add('is-ready');
          this.show(0);

          this.addEventListener('click', (event) => {
            const thumb = event.target.closest('[data-goto]');
            if (thumb) return this.show(Number(thumb.dataset.goto));
            const arrow = event.target.closest('[data-step]');
            if (arrow) return this.show(this.index + Number(arrow.dataset.step));
          });
        }

        show(next) {
          const total = this.shots.length;
          this.index = ((next % total) + total) % total;
          this.shots.forEach((shot, i) => shot.classList.toggle('is-active', i === this.index));
          this.thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === this.index);
            thumb.setAttribute('aria-current', i === this.index ? 'true' : 'false');
          });
          if (this.counter) this.counter.textContent = `${this.index + 1} / ${total}`;
          if (this.live) this.live.textContent = `Image ${this.index + 1} of ${total}`;
        }
      }
    );
  }

  if (!customElements.get('bevgru-product-form')) {
    customElements.define(
      'bevgru-product-form',
      class BevgruProductForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.idInput = this.querySelector('[data-variant-id]');
          this.addButton = this.querySelector('[data-add]');
          this.status = this.querySelector('[data-status]');
          this.qtyInput = this.querySelector('[data-qty-input]');

          const data = this.querySelector('[data-variant-data]');
          this.variants = data ? JSON.parse(data.textContent) : [];

          this.paintOptionPrices();
          this.update();

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-option-value]')) this.update();
          });

          this.addEventListener('click', (event) => {
            const step = event.target.closest('[data-qty]');
            if (step && this.qtyInput) {
              const next = Number(this.qtyInput.value) + Number(step.dataset.qty);
              this.qtyInput.value = Math.min(99, Math.max(1, next));
            }
            const sticky = event.target.closest('[data-sticky-add]');
            if (sticky) this.form.requestSubmit();
          });

          if (this.dataset.ajax === 'true') {
            this.form.addEventListener('submit', (event) => {
              event.preventDefault();
              this.add();
            });
          }

          this.deliveryEstimate();
          this.watchScroll();
        }

        get selected() {
          return Array.from(this.querySelectorAll('[data-option-value]:checked')).map((input) => input.value);
        }

        /* A one-option product is a pack ladder: put the price on the card. */
        paintOptionPrices() {
          const groups = this.querySelectorAll('.bev-pdp__options');
          if (groups.length !== 1) return;
          this.querySelectorAll('.bev-pdp__option').forEach((label) => {
            const match = this.variants.find((v) => v.options[0] === label.dataset.value);
            if (!match) return;
            label.querySelector('[data-option-price]').textContent = match.price;
            label.querySelector('[data-option-unit]').textContent = match.unit ? `${match.unit} a can` : '';
            label.classList.toggle('is-unavailable', !match.available);
          });
        }

        update() {
          const chosen = this.selected;
          const variant = chosen.length
            ? this.variants.find((v) => v.options.every((value, i) => value === chosen[i]))
            : this.variants[0];
          if (!variant) return;
          this.variant = variant;

          if (this.idInput) this.idInput.value = variant.id;
          this.querySelectorAll('[data-price]').forEach((el) => (el.textContent = variant.price));
          const compare = this.querySelector('[data-compare]');
          if (compare) {
            compare.textContent = variant.compare_at;
            compare.hidden = !variant.has_compare;
          }
          const badge = this.querySelector('[data-off]');
          if (badge) {
            badge.textContent = variant.badge || '';
            badge.hidden = !variant.badge;
          }
          const unit = this.querySelector('[data-unit]');
          if (unit && variant.unit) unit.textContent = variant.unit;
          const stickyVariant = this.querySelector('[data-sticky-variant]');
          if (stickyVariant) stickyVariant.textContent = chosen.join(' / ');

          if (this.addButton) {
            this.addButton.disabled = !variant.available;
            if (!variant.available) this.addButton.textContent = 'Sold out';
          }

          // Same behaviour as a native Shopify variant change: the URL carries the
          // choice, so a shared link and a refresh both land on it.
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
          this.syncSiblings();
        }

        /* Carry the chosen pack across to the other flavours. */
        syncSiblings() {
          const chosen = this.selected;
          if (!chosen.length) return;
          this.querySelectorAll('[data-sibling]').forEach((link) => {
            let variants = [];
            try {
              variants = JSON.parse(link.dataset.variants);
            } catch (error) {
              return;
            }
            const match = variants.find((v) => chosen.every((value) => v.options.includes(value)));
            link.href = match ? `${link.dataset.baseUrl}?variant=${match.id}` : link.dataset.baseUrl;
          });
        }

        deliveryEstimate() {
          const note = this.querySelector('[data-delivery]');
          const range = this.querySelector('[data-delivery-range]');
          if (!note || !range) return;
          const fmt = (days) => {
            const date = new Date();
            date.setDate(date.getDate() + days);
            return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
          };
          range.textContent = `${fmt(3)} to ${fmt(6)}`;
          note.hidden = false;
        }

        watchScroll() {
          const sentinel = this.querySelector('.bev-pdp__sentinel');
          const bar = this.querySelector('[data-sticky]');
          if (!sentinel || !bar || typeof IntersectionObserver === 'undefined') return;
          new IntersectionObserver(
            ([entry]) => bar.classList.toggle('is-shown', !entry.isIntersecting),
            { rootMargin: '-120px 0px 0px 0px' }
          ).observe(sentinel);
        }

        async add() {
          const label = this.addButton.textContent;
          this.addButton.disabled = true;
          this.addButton.textContent = 'Adding…';
          try {
            await window.bevgruCartAdd(this.idInput.value, Number((this.qtyInput && this.qtyInput.value) || 1));
            this.addButton.textContent = 'Added ✓';
            if (this.status) this.status.hidden = false;
          } catch (error) {
            this.addButton.textContent = 'Could not add';
            console.error('[bevgru] add to cart failed', error);
          } finally {
            setTimeout(() => {
              this.addButton.disabled = false;
              this.addButton.textContent = label;
            }, 2200);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
